import VueRouter from 'vue-router'
import routes from './routeList'
import { fromUnixTime } from 'date-fns'

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
   // Exists when Browser's back/forward pressed
    if (savedPosition) {
      return savedPosition
    // For anchors
    } else if (to.hash) {
      return { selector: to.hash }
    // By changing queries we are still in the same component, so "from.path" === "to.path" (new query changes just "to.fullPath", but not "to.path").
    } else if (from.path === to.path) {
      return {}
    }

    // Scroll to top
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) =>{
  const srAccessToken = localStorage.getItem("srAccessToken")
  if(srAccessToken) {
    if(to.path === "/login"){next({path: "/member"})}
    else{
      if(from.name) next()
      else{
         next()
      }
    }
  }else{
    if(to.meta.requiresAuth) {
      next({path: '/login'})
    }else{
      next()
    }
  }
})

export default router
